import useHttp from "../hooks/useHttp";
import React, { useState, createContext, useEffect } from "react";

export const PostContext = createContext();

const PostContextProvider = (props) => {
  const [posts, setPosts] = useState([]);
  const [postNum, setPostNum] = useState(0);
  const updatePostNum = () => {
    setPostNum(postNum + 1);
  }
  const updatePosts = (post) => {
    setPosts((prevPosts) => [...prevPosts, ...post]);
  };
  const loadPosts = () => {
    setPosts();
  };
  const initPosts = () => {
    setPosts();
  };
  const { isLoading, error, sendRequest: fetchPosts } = useHttp();

  useEffect(() => {
    const transformPosts = (fetchedPosts) => {
      console.log("post:" + fetchedPosts);
      setPosts(fetchedPosts);
    };
    fetchPosts({ url: "/api/users/posts/0" }, transformPosts);
  }, [fetchPosts]);

  return (
    <PostContext.Provider value={{ posts, postNum, updatePostNum, updatePosts, loadPosts, initPosts }}>
      {props.children}
    </PostContext.Provider>
  );
};

export default PostContextProvider;